var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPublicChecklist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M25.3334 3.33337H14.6667C11.8665 3.33337 10.4664 3.33337 9.3968 3.87834C8.45599 4.35771 7.69108 5.12261 7.21172 6.06342C6.66675 7.13298 6.66675 8.53311 6.66675 11.3334V28.6667C6.66675 31.467 6.66675 32.8671 7.21172 33.9367C7.69108 34.8775 8.45599 35.6424 9.3968 36.1217C10.4664 36.6667 11.8664 36.6667 14.6666 36.6667H20.0001L33.3334 20.8334V11.3334C33.3334 8.53311 33.3334 7.13298 32.7884 6.06342C32.3091 5.12261 31.5442 4.35771 30.6034 3.87834C29.5338 3.33337 28.1337 3.33337 25.3334 3.33337Z",
    fill: "#6868FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3334 20.8334V11.3334C33.3334 8.53311 33.3334 7.13298 32.7884 6.06342C32.3091 5.12261 31.5442 4.35771 30.6034 3.87834C29.5338 3.33337 28.1337 3.33337 25.3334 3.33337H14.6667C11.8665 3.33337 10.4664 3.33337 9.3968 3.87834C8.45599 4.35771 7.69108 5.12261 7.21172 6.06342C6.66675 7.13298 6.66675 8.53311 6.66675 11.3334V28.6667C6.66675 31.467 6.66675 32.8671 7.21172 33.9367C7.69108 34.8775 8.45599 35.6424 9.3968 36.1217C10.4664 36.6667 11.8665 36.6667 14.6667 36.6667H20.0001M23.3334 18.3334H13.3334M16.6667 25H13.3334M26.6667 11.6667H13.3334M24.1667 31.6667L27.5001 35L35.0001 27.5",
    stroke: "#6868FE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicChecklist);
export default __webpack_public_path__ + "static/media/public-checklist.daa9d4467424d274cc2271de8bc7667b.svg";
export { ForwardRef as ReactComponent };